import {
  Box,
  Grid,
  TextField,
  Button,
  CircularProgress
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import QuestionCard from "./QuestionCard";
import PracticePageLayout, {
  inputSx,
  primaryButtonSx
} from "./PracticePageLayout";

const ResumeQuestions = () => {
  const [resume, setResume] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [conversationText, setConversationText] = useState([]);
  const [audioKeys, setAudioKeys] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [blobURLs, setBlobURLs] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [responseTexts, setResponseTexts] = useState([]);
  const handleResponseTextChange = (index, responseText) => {
    const newResponseTexts = [...responseTexts];
    newResponseTexts[index] = responseText;
    setResponseTexts(newResponseTexts);
  };
  const handleConversationTextChange = newItems => {
    setConversationText([...conversationText, ...newItems]);
    console.log([...conversationText, ...newItems]);
  };
  const handleBlobURLChange = (index, blobURL) => {
    const newBlobURLs = [...blobURLs];
    newBlobURLs[index] = blobURL;
    setBlobURLs(newBlobURLs);
  };
  const handleFeedbackChange = (index, feedback) => {
    const newFeedbacks = [...feedbacks];
    newFeedbacks[index] = feedback;
    setFeedbacks(newFeedbacks);
  };
  const handleAudioKeyChange = (index, audioKey) => {
    const newAudioKeys = [...audioKeys];
    newAudioKeys[index] = audioKey;
    setAudioKeys(newAudioKeys);
  };
  useEffect(() => {
    setCurrentQuestionIndex(0);
  }, [questions]);
  const handlePrevQuestion = () => {
    setCurrentQuestionIndex(currentQuestionIndex - 1);
  };

  const handleNextQuestion = () => {
    setCurrentQuestionIndex(currentQuestionIndex + 1);
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    let fullQuery = `Act as an interviewer for the following job posting "${jobDescription}", along with the job posting here is the interviewees resume "${resume}", please generate ten questions specific to the job posting and interviewees resume, the questions should ask about the interviewees experience from their resume as well as questions that would reveal if the interviewee is a good fit for the company. Please format your response as a JSON with an array of ten strings, with each string containing a question. For example:

    {
      "questions": [
        //List of questions for the specific job posting and resume
      ]
    }

    If there is nothing to say about a particular field, simply leave the array empty. Please make sure to use the exact field names provided (questions), and include double quotes around all strings. Do not include any additional text in your response
    `;
    const request = { role: "user", content: fullQuery };
    try {
      await API.post("chatEndpoints", "/chat/completion", {
        body: [...conversationText, request],
        headers: { "Content-Type": "application/json" }
      }).then(res => {
        const result = res.query;
        console.log(res);
        handleConversationTextChange(request, result);
        const json = JSON.parse(result.content);
        const newQuestions = json.questions.map(question => question);
        setQuestions(newQuestions);
        setBlobURLs(new Array(newQuestions.length).fill(""));
        setAudioKeys(new Array(newQuestions.length).fill(""));
        setResponseTexts(new Array(newQuestions.length).fill(""));
        setFeedbacks(new Array(newQuestions.length).fill(""));
        setLoading(false);
        console.log(newQuestions);
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  const questionCards = questions.map((question, index) => {
    return (
      <QuestionCard
        key={index}
        question={question}
        index={index}
        total={questions.length}
        conversation={conversationText}
        blobURL={blobURLs[index]}
        audioKey={audioKeys[index]}
        responseText={responseTexts[index]}
        feedback={feedbacks[index]}
        onBlobURLChange={blobURL => handleBlobURLChange(index, blobURL)}
        onAudioKeyChange={audioKey => handleAudioKeyChange(index, audioKey)}
        onResponseTextChange={responseText =>
          handleResponseTextChange(index, responseText)
        }
        onConversationTextChange={handleConversationTextChange}
        onFeedbackChange={feedback => handleFeedbackChange(index, feedback)}
        next={handleNextQuestion}
        prev={handlePrevQuestion}
      />
    );
  });

  return (
    <PracticePageLayout
      icon={<AssignmentIndOutlinedIcon />}
      kicker="Resume × posting"
      title="Cross-reference your resume against the role."
      subtitle="Paste both. We'll write questions that probe your real experience and test your fit for the position."
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Your resume"
            multiline
            rows={10}
            fullWidth
            variant="outlined"
            sx={inputSx}
            value={resume}
            onChange={e => setResume(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Job description"
            multiline
            rows={10}
            fullWidth
            variant="outlined"
            sx={inputSx}
            value={jobDescription}
            onChange={e => setJobDescription(e.target.value)}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 1.5 }}>
        <Button
          sx={primaryButtonSx}
          variant="contained"
          onClick={handleSubmit}
          disabled={!resume || !jobDescription || loading}
        >
          {loading ? "Generating…" : "Generate questions"}
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : questions.length > 0 ? (
        <Box sx={{ mt: 4 }}>{questionCards[currentQuestionIndex]}</Box>
      ) : null}
    </PracticePageLayout>
  );
};

export default ResumeQuestions;
